<template>
  <section class="hbox stretch">
    <div class="content-header">      
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item><a href="/">运营</a></el-breadcrumb-item>
        <el-breadcrumb-item>特约商户</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="content-main">
      <el-form :inline="true">            
        <el-form-item>
          <el-button type="primary" class="el-icon-circle-plus-outline" v-on:click="Add" >新增</el-button>
        </el-form-item>
        <el-form-item >
          <el-input  placeholder="联系人名称" v-model="name"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" v-on:click="Search" >查询</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="rows" style="width: 100%">
        <el-table-column prop="Business_Info_merchant_shortname"  label="商户简称" > </el-table-column>
        <el-table-column prop="Sub_Mchid"  label="特约商户号" > </el-table-column>
        <el-table-column prop="Contact_Info_contact_name"  label="联系人" > </el-table-column>
        <el-table-column prop="Contact_Info_mobile_phone"  label="联系人电话" > </el-table-column>
        <el-table-column prop="Subject_Info_subject_type"  label="主体类型" > 
          <template slot-scope="scope">
            <span v-if="scope.row.Subject_Info_subject_type=='SUBJECT_TYPE_ENTERPRISE'">企业</span>
            <span v-if="scope.row.Subject_Info_subject_type=='SUBJECT_TYPE_INDIVIDUAL'">个体户</span>
          </template>
        </el-table-column>
        <el-table-column prop="State"  label="状态" > 
          <template slot-scope="scope">
            <span v-if="scope.row.State=='APPLYMENT_STATE_EDITTING'">编辑中</span>
            <span v-if="scope.row.State=='APPLYMENT_STATE_AUDITING'">审核中</span>
            <span v-if="scope.row.State=='APPLYMENT_STATE_REJECTED'">已驳回</span>
            <span v-if="scope.row.State=='APPLYMENT_STATE_TO_BE_CONFIRMED'">待账户验证</span>
            <span v-if="scope.row.State=='APPLYMENT_STATE_TO_BE_SIGNED'">待签约</span>
            <span v-if="scope.row.State=='APPLYMENT_STATE_SIGNING'">开通权限中</span>
            <span v-if="scope.row.State=='APPLYMENT_STATE_FINISHED'">已完成</span>
            <span v-if="scope.row.State=='APPLYMENT_STATE_CANCELED'">已作废</span>
          </template>
        </el-table-column>
        <el-table-column  fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <el-button @click.native.prevent="Edit(scope.row.Id)" type="text" size="small">编辑</el-button>
            <el-button v-if="scope.row.State=='APPLYMENT_STATE_EDITTING'" @click="DeleteRow(scope.row.Id)" type="text" size="small">&nbsp; 删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :hide-on-single-page="true"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageIndex"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount">
      </el-pagination>
    </div>      
  </section>
</template>
<script  type='text/ecmascript-6'>
  export default {
    props:{
    },
    data (){
      return {
        name:'',
        pageIndex:1,
        pagesize:10,
        totalCount:10,
        sort:'Id desc',
        rows:[]   
        
      }
    },
    computed:{
    },
    mounted(){
      this.GetDate();
    },
    components:{
    },
    methods:{     
      Search:function(){
        this.pageIndex = 1;
        this.GetDate();
      },
      Add:function(){
        this.$router.push({
          name:'wxMerchantInfo',
          params:{
            Id:0
          }
        })
      },
      Edit(id){
        this.$router.push({
          name:'wxMerchantInfo',
          params:{
            Id:id
          }
        })
      },
      GetDate:function(){
        var that = this
        this.axios({
          method:'get',
          url:that.global.serverSrc + '/api/Wechat/MerchantList',
          params:{
            name : that.name,
            pageIndex : that.pageIndex,
            pagesize : that.pagesize,
            sort : that.sort
          }
        }).then(function (resp) {
          that.totalCount = resp.data.totalCount
          that.rows = resp.data.data
          console.log(that.rows)
        }).catch(resp => {
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
      },
      DeleteRow(id) {
        this.$confirm('确定要删除该记录吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var that = this
          this.axios({
            method:'post',
            url:that.global.serverSrc + '/api/BusinessCircle/Delete',
            data:{
              id: id
            }
          }).then(function (resp) {  
            if(resp.data.errorCode==0){              
              that.$message.success(resp.data.message);
              that.GetDate();
            }else {              
              that.$message.warning(resp.data.message);
            }
          }).catch(resp => {
            console.log('请求失败：' + resp.message + ',' + resp.stack)
          })
        }).catch(() => {
            
        });
      }
    },
    created(){
    
    },
  }
</script>
<style lang='stylus' rel='stylesheet/stylus'>
.content-header
  padding 24px
  border 1px solid #C0C4CC
.content-main
  padding 24px  
.map
  width: 100%;
  height: 200px;
</style>